<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="信息通知" name="first">
        <div style="margin-left: 15px;width: 100%;">
          <a href="https://www.hanyangtelecom.com/news/news.php?class2=37">
            <div class="more"><span class="colorStyle" style="font-size: 14px;font-weight: 600;">更多</span><i style="margin: 10px 6% 10px 0;font-size: 13px;font-weight: 700" class="el-icon-arrow-right"/></div>
          </a>
          <div v-for="(item, index) in messageList" :key="index" style="padding: 8px 0px">
            <a :href="url+item.router">
            <div style="display: flex;flex-direction: row;justify-content: space-between">
              <div class="title_style colorStyle"><i style="margin-right: 10px" class="el-icon-caret-right"/>{{ item.title }}</div>
              <div class="colorStyle" style="font-size: 14px;margin-right: 6%;color: #7c7979">{{item.data}}</div>
            </div>
            </a>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'Homepage',
  data () {
    return {
      activeName: 'first',
      url: 'https://www.hanyangtelecom.com/news/shownews.php?id=',
      messageList: [
        {id: 1, title: '以练筑防 筑牢安全防线', data: '2025-08-05 10:03:05', router: '191'},
        {id: 2, title: '专题党课推动落实中央八项规定精神学习教育', data: '2025-08-05 09:56:19', router: '190'},
        {id: 3, title: '以学正风 走深走实', data: '2025-08-05 09:48:30', router: '189'},
        {id: 4, title: '开展双项安全学习 共筑企业安全屏障', data: '2025-07-01 10:29:21', router: '188'},
        {id: 5, title: '校企合作结硕果瀚洋电信实习生助力幼教咨询专线服务', data: '2025-07-01 10:27:51', router: '187'},
        {id: 6, title: '瀚洋公司受邀参加2025年第十二届CC-CMM 国际标准年度论坛', data: '2025-07-01 10:24:29', router: '186'},
        {id: 7, title: '强化作风建设 筑牢党性根基——瀚洋各支部扎实开展深入贯彻中央八项规定精神学习教育', data: '2025-07-01 10:23:43', router: '185'},
        {id: 8, title: '学急救技能 筑生命防线', data: '2025-06-04 13:25:21', router: '184'}
      ]
    }
  },
  methods: {
    more (val) {
      this.$router.push({
        name: '/home/More',
        query: val
      })
    },
    detail (val) {
      this.$router.push({
        name: '/home/AnnouncementDetail',
        query: val
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .more{
    text-align: right;
  }
  .title_style{
    font-size: 14px;
    width: 70%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 10px;
    box-sizing: border-box
  }
  ::v-deep .el-tabs__nav-wrap {
    overflow: hidden;
    margin-bottom: -1px;
    position: relative;
    background-color: #409EFF;
    border-radius: 20px;
    padding: 0 10px;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #fff;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    content: none;
    background-color: #fff;
  }
  ::v-deep .el-tabs__item {
    color: #303133;
  }
  ::v-deep .el-tabs__item:hover {
    color: #fff;
  }
  .company{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
   flex-direction: column;
    align-items: center;
  }
  .colorStyle{
    color: #5f5a5a;
  }
  .colorStyle:hover{
    color: #928a8a !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/Message.vue